import angular from 'angular';

// Libraries
import uiModal from 'angular-ui-bootstrap/src/modal';

// Dependencies
import '../../../../../lib/service';
import imageModal from '../imageModal';

// Controller
import PositionDetailsModalController from './positionDetailsModal.controller';
import template from './positionDetailsModal.html';

const moduleName = 'staff.dashboardScreen.positionDetailsModal';
let module = angular.module(moduleName, [
  uiModal,
  imageModal.name
]);

module.controller('PositionDetailsModalController', PositionDetailsModalController);

module.factory('positionDetailsModal', ['$uibModal', '$q', ($uibModal, $q, date) => {
  return props => {
    let modal = $uibModal.open({
      animate: false,
      template: template,
      controller: PositionDetailsModalController,
      controllerAs: 'vm',
      size: 'lg',
      resolve: {
        $q: () => $q,
        position: () => props.position,
        modalClass: () => props.modalClass,
      }
    });
    return modal.result;
  };
}]);

export default module;

